// assets
import Load from "assets/svg/other/loading2.svg";
import Header from 'components/dashHeader';
//css 
import 'pages/styles/dashboard/Home.css';
import React, { useEffect, useRef, useState } from 'react';
import { Link, useHistory } from "react-router-dom";
import { useStore } from "store";
import styled from 'styled-components';
import { get } from "util/axiosLib";
import { logger } from "util/logger";
import { isEmpty, makeCancelable, properCase } from "util/utils";


export default function HomeReceive() {
    const { store, localsocket } = useStore();
    const history = useHistory();
    const [pageState, setPageState] = useState('loading');
    const [sendData, setSendData] = useState({});
    const cancelableFetch = useRef();

    const fetchReceivable = async () => {
      try {
        const token = store.token;
        const headers = {
          authorization: `${token}`,
          "Content-Type": "application/json",
        };

        const sendRef = history?.location?.pathname.replace('/invoice/', '');

        if(isEmpty(sendRef)) {
          return setPageState('notFound');
        }

        const baseUrl = `${process.env.REACT_APP_API_ENDPOINT}/wallet/send/across/${sendRef}`;

        const getTransactionsReq = await get(baseUrl, headers);

        const rawTx = getTransactionsReq?.data?.data;

        setSendData({...rawTx, lastFectched: new Date()});
        setPageState("ready");
      } catch (err) {
        if (err?.isAxiosError) {
          if (err?.response?.status === 401) {
            return localsocket && localsocket?.emit("LOGOUT");
          } else if (err?.response?.status === 403) {
            return setPageState("notFound");          
          } else if (err?.response?.status === 404) {
            return setPageState("notFound");
          }
        } else {
          logger("ERROR:: ", err);
        }
        setPageState("error");
        // setTransactionError(String(err))
      }
    };

    useEffect(() => {
      cancelableFetch.current = makeCancelable(fetchReceivable());

      return () => {
        cancelableFetch.current && cancelableFetch.current.cancel();
      };
      // eslint-disable-next-line
    }, []);

        return (
          <>
            <Header />
            <SendCard sendData={sendData} pageState={pageState} setSendData={setSendData} setPageState={setPageState}/>
          </>
        );
}

var NotFound = ({homeSend, homeClose}) => {
  const {store} = useStore();
  return (
    <>
      <div className="flex flex-col">
        <div className="flex justify-center">
          <h2 className="text-center">
            {!homeSend ? 'The page you are looking for cannot be found.' : 'Transaction not found.'}
          </h2>
        </div>

        <div className="mt-8 gap-6">
          {homeClose ? <div className="green bold" onClick={() => homeClose()}>Close</div> :
          <Link to={store.isLoggedIn ? `/dashboard/wallet` : "/"} className="green bold">
            Go to Home
          </Link>}
        </div>
      </div>
    </>
  );
}

export var SendCard = ({
  sendData,
  pageState,
  // seStendData,
  // setPageState,
  homeClose,
  homeSend,
}) => {
  const { store } = useStore();
  const addr = `${sendData?.receipientData?.receivingIntoLabel} ${sendData?.receipientData?.receivingIntoAddress}`;

  return (
    <StyledDiv>
      <div id="invoiceholder" className={`${homeSend ? "homeReceive" : ""}`}>
        {!homeSend && <div id="headerimage" />}
        <div
          id="invoice"
          className={`effect2 ${homeSend ? "homeReceive" : ""} ${
            ["notFound", "loading", "error"].includes(pageState)
              ? "no-content"
              : ""
          }`}
        >
          {pageState === "loading" ? (
            <div className="grid-center">
              <div className="loading-a" id="load">
                <img src={Load} alt="loading" />
              </div>
            </div>
          ) : pageState === "notFound" ? (
            <NotFound homeSend homeClose={homeClose}/>
          ) : (
            <>
              <div id="invoice-top">
                <div className="logo" />
                <div className="info">
                  <h2>{` ${properCase(sendData?.sender?.lastName || '')} ${properCase(
                    sendData?.sender?.firstName
                  )}`}</h2>
                  <p>
                    {String(sendData?.sender?.email || '').toLowerCase()} <br />
                  </p>
                </div>
                {/*End Info*/}
                <div className="title">
                  <h1 style={{ textAlign: "right" }}>
                    {sendData?.outgoingState === "gone"
                      ? "Fund Transfer"
                      : "Send Request"}
                  </h1>
                  <p>
                    Date:{" "}
                    {String(sendData?.createdAt)
                      .split(":")[0]
                      .slice(0, -2)
                      .trim()}
                    <br />
                    Transaction Date:{" "}
                    {String(sendData?.updatedAt)
                      .split(":")[0]
                      .slice(0, -2)
                      .trim()}
                  </p>
                </div>
                {/*End Title*/}
              </div>
              {/*End InvoiceTop*/}
              <div id="invoice-mid">
                <div className="clientlogo" />
                {sendData?.receipient && (
                  <div className="info">
                    <h2>{`${sendData?.receipient?.name || ""}`}</h2>
                    <p>
                      {`${sendData?.receipient?.email || ""}`}
                      <br />
                      {sendData?.receipient?.phoneNumber || ""}
                      <br />
                    </p>
                  </div>
                )}
                <div id="project">
                  <h2>Description</h2>
                  <p>{sendData?.remark ?? "N/A"}</p>
                </div>
              </div>
              {/*End Invoice Mid*/}
              <div id="invoice-bot" className={sendData?.outgoingState ?? ""}>
                <table
                  className={`invoice-tx--table ${
                    sendData?.outgoingState ?? ""
                  }`}
                >
                  <tbody>
                    <tr>
                      <td style={{ height: "35px" }} />
                    </tr>
                    <tr>
                      <td
                        colSpan={2}
                        style={{
                          padding: "10px 20px",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "14px",
                            margin: "0 0 8px 0",
                          }}
                        >
                          <span
                            style={{
                              fontWeight: "bold",
                              display: "inline-block",
                              minWidth: "150px",
                            }}
                          >
                            Transaction status
                          </span>
                          <b
                            style={{
                              fontWeight: "normal",
                              margin: 0,
                            }}
                            className={`paystate-${
                              sendData?.outgoingState ?? ""
                            }`}
                          >
                            {sendData?.outgoingState === "open"
                              ? "Pending"
                              : sendData?.outgoingState === "going"
                              ? "Processing"
                              : sendData?.outgoingState === "gone"
                              ? "Sent"
                              : properCase(sendData?.outgoingState)}
                          </b>
                        </p>
                        <p
                          style={{
                            fontSize: "14px",
                            margin: "0 0 8px 0",
                          }}
                        >
                          <span
                            style={{
                              fontWeight: "bold",
                              display: "inline-block",
                              minWidth: "146px",
                            }}
                          >
                            Reference
                          </span>{" "}
                          {sendData?._id}
                        </p>
                        <p style={{ fontSize: "14px", margin: "0 0 8px 0" }}>
                          <span
                            style={{
                              fontWeight: "bold",
                              display: "inline-block",
                              minWidth: "146px",
                            }}
                          >
                            Transaction amount
                          </span>{" "}
                          {`${Number(
                            Number(sendData?.destinationAmount ?? 0).toFixed(8)
                          )} ${String(
                            sendData?.destinationUnit
                          ).toUpperCase()} `}
                        </p>
                        {store &&
                        store?.isSignedIn &&
                        store?.token &&
                        store?.userData?.userId === sendData?.sender?.userId ? (
                          <>
                            <p
                              style={{ fontSize: "14px", margin: "0 0 8px 0" }}
                            >
                              <span
                                style={{
                                  fontWeight: "bold",
                                  display: "inline-block",
                                  minWidth: "146px",
                                }}
                              >
                                Transaction fee
                              </span>{" "}
                              {`${Number(
                                Number(sendData?.transferFee ?? 0).toFixed(8)
                              )} ${String(
                                sendData?.sourceUnit
                              ).toUpperCase()} `}
                            </p>
                            <p
                              style={{ fontSize: "14px", margin: "0 0 8px 0" }}
                            >
                              <span
                                style={{
                                  fontWeight: "bold",
                                  display: "inline-block",
                                  minWidth: "146px",
                                }}
                              >
                                Transaction Value
                              </span>{" "}
                              {`${Number(
                                Number(sendData?.sourceAmount ?? 0).toFixed(8)
                              )} ${String(
                                sendData?.sourceUnit
                              ).toUpperCase()} `}
                            </p>
                          </>
                        ) : null}
                        <p style={{ fontSize: "14px", margin: "0 0 8px 0" }}>
                          <span
                            style={{
                              fontWeight: "bold",
                              display: "inline-block",
                              minWidth: "146px",
                            }}
                          >
                            Receipient Name
                          </span>
                          <>
                            <span>{`${sendData?.receipient?.name}`}</span>
                          </>
                        </p>
                        <p style={{ fontSize: "14px", margin: "0 0 8px 0" }}>
                          <span
                            style={{
                              fontWeight: "bold",
                              display: "inline-block",
                              minWidth: "146px",
                            }}
                          >
                            Payment Address
                          </span>
                          <>
                            <span>
                              {addr.length > 20 ? `${addr.slice(0, 15)}...${addr.slice(
                                addr?.length - 5
                              )}`: addr}
                            </span>
                          </>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ height: "35px" }} />
                    </tr>
                  </tbody>
                </table>
                {/* 
                
                {store &&
                store?.isSignedIn &&
                store?.token &&
                store?.userData?.userId === invoiceData?.payee?.userId ? (
                  invoiceData?.receivableState === "open" ? (
                    <form
                      method="post"
                      target="_top"
                      onSubmit={(e) => {
                        e.preventDefault();
                        handleCancel && handleCancel();
                      }}
                    >
                      <button className="pwtbmm cancel-invoice">
                        Cancel Invoice
                      </button>
                    </form>
                  ) : null
                ) : (
                  <form
                    method="post"
                    target="_top"
                    onSubmit={() => history.push("/dashboard/wallet")}
                  >
                    <button className="pwtbmm">Pay with Bitmama</button>
                  </form>
                )} */}
                <div id="legalcopy">
                  {sendData?.outgoingState !== "gone" && (
                    <p className="legal">
                      <strong style={{ color: "red" }}>
                        THIS IS NOT A PROOF OF PAYMENT!
                      </strong>
                      &nbsp; <br />
                      <br />
                      This transaction is currently being processed and if not
                      successfully processed before{" "}
                      {String(sendData?.timeline?.dueAt)
                        .split(":")[0]
                        .slice(0, -2)
                        .trim()}{" "}
                      would be credited back in favour of the originator.
                    </p>
                  )}
                  {sendData?.outgoingState === "gone" && (
                    <p className="legal">
                      <strong style={{ color: "green" }}>
                        This is a proof of payment to{" "}
                        {`${sendData?.receipientData?.receivingIntoLabel}`}{" "}
                        {`${sendData?.receipientData?.receivingIntoAddress}`}
                      </strong>
                      &nbsp; <br />
                      <br />
                      {/* This transaction can be . */}
                    </p>
                  )}
                </div>
              </div>
              {/*End InvoiceBot*/}
            </>
          )}
        </div>
        {/*End Invoice*/}
      </div>
    </StyledDiv>
  );
};

var StyledDiv = styled.div`
  .copyTc {
    background: green;
    opacity: 0.8;
    color: white;
    font-weight: 600;
    padding: 4px 8px;
  }
  .paystate {
    &-cancelled,
    &-timeout,
    &-failed,
    &-cancelled,
    &-reversed {
      color: #ed2e7e;
    }
    &-going {
      color: steeleblue;
    }
    &-open {
      color: orange;
    }
    &-gone {
      color: green;
    }
  }
  .pwtbmm {
    padding: 8px 1rem;
    background-color: green;
    outline: none;
    color: white;
    border: none;

    &.cancel-invoice {
      background-color: #ed2e7e;
    }
  }
  .grid-center {
    width: 100%;
    postion: relative;
    display: grid;
    place-content: center;
    .loading-a {
      width: 100%;
      left: 0;
      position: relative;
      height: 4em;
      padding: 1em;
      font-size: 0.9em;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 3;

      &.actioning {
        opacity: 0.75;
        padding: unset;
        height: unset;
      }
    }
  }
  .invoice-tx--table {
    max-width: 670px;
    margin: 0px auto 10px;
    background-color: #fff;
    padding-top: unset;
    border-radius: 3px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    border-top: solid 10px green;

    &.cancelled {
      border-color: #ed2e7e;
    }
    &.cancelled,
    &.timeout,
    &.failed,
    &.cancelled,
    &.reversed {
      border-color: #ed2e7e;
    }
    &.going {
      border-color: steeleblue;
    }
    &.open {
      border-color: orange;
    }
    &.gone {
      border-color: green;
    }
  }
  .home-container {
    margin-left: unset;
    .invoice-content {
      display: grid;
      place-content: center;
    }
  }

  ::selection {
    background: #f31544;
    color: #fff;
  }
  ::moz-selection {
    background: #f31544;
    color: #fff;
  }
  h1 {
    font-size: 1.5em;
    color: #222;
  }
  h2 {
    font-size: 0.9em;
  }
  h3 {
    font-size: 1.2em;
    font-weight: 300;
    line-height: 2em;
  }
  p {
    font-size: 0.7em;
    color: #666;
    line-height: 1.2em;
  }

  #invoiceholder {
    width: 100%;
    hieght: 100%;
    padding-top: 50px;
    &.homeReceive {
      padding-top: 0px;
    }
  }
  #headerimage {
    z-index: -1;
    position: relative;
    top: -50px;
    height: 350px;
    background-image: url("/images/invoicebg.jpg");

    -webkit-box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15),
      inset 0 -2px 4px rgba(0, 0, 0, 0.15);
    -moz-box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15),
      inset 0 -2px 4px rgba(0, 0, 0, 0.15);
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15),
      inset 0 -2px 4px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    background-attachment: fixed;
    background-size: 1920px 80%;
    background-position: 50% -90%;
  }
  #invoice {
    position: relative;
    top: -290px;
    margin: 0 auto;
    width: 700px;
    background: #fff;
    &.homeReceive {
      width: 100%;
      top: unset;
    }
    &.no-content {
      top: -50%;
      text-align: center;
    }
  }

  [id*="invoice-"] {
    /* Targets all id with 'col-' */
    border-bottom: 1px solid #eee;
    padding: 30px;
  }

  #invoice-top {
    min-height: 120px;
  }
  #invoice-mid {
    min-height: 120px;
  }
  #invoice-bot {
    min-height: 250px;
  }

  .logo {
    float: left;
    height: 60px;
    width: 60px;
    background: url(/images/logo1.png) no-repeat;
    background-size: 60px 60px;
  }
  .clientlogo {
    float: left;
    height: 60px;
    width: 60px;
    background: url(/images/client.jpg) no-repeat;
    background-size: 60px 60px;
    border-radius: 50px;
  }
  .info {
    display: block;
    float: left;
    margin-left: 20px;
  }
  .title {
    float: right;
    font-size: 0.75rem;
  }
  .title p {
    text-align: right;
  }
  #project {
    margin-left: 52%;
  }
  table {
    width: 100%;
    border-collapse: collapse;
  }
  td {
    padding: 15px 0 5px 15px;
  }
  .tabletitle {
    padding: 5px;
    background: #eee;
  }
  .service {
    border: 1px solid #eee;
  }
  .item {
    width: 50%;
  }
  .itemtext {
    font-size: 0.9em;
  }

  #legalcopy {
    margin-top: 30px;
  }
  form {
    float: right;
    margin-top: 30px;
    text-align: right;
  }

  .effect2 {
    position: relative;
  }
  .effect2:before,
  .effect2:after {
    z-index: -1;
    position: absolute;
    content: "";
    bottom: 15px;
    left: 10px;
    width: 50%;
    top: 80%;
    max-width: 300px;
    background: #777;
    -webkit-box-shadow: 0 15px 10px #777;
    -moz-box-shadow: 0 15px 10px #777;
    box-shadow: 0 15px 10px #777;
    -webkit-transform: rotate(-3deg);
    -moz-transform: rotate(-3deg);
    -o-transform: rotate(-3deg);
    -ms-transform: rotate(-3deg);
    transform: rotate(-3deg);
  }
  .effect2:after {
    -webkit-transform: rotate(3deg);
    -moz-transform: rotate(3deg);
    -o-transform: rotate(3deg);
    -ms-transform: rotate(3deg);
    transform: rotate(3deg);
    right: 10px;
    left: auto;
  }

  .legal {
    width: 70%;
  }
`;


